import { useEffect, useState } from 'react'

import { api } from 'services/api'

import * as T from 'types'

const useSelectedListing = () => {
  const [listingId, setListingId] = useState<string>('')
  const handleHighlightedListingChange = (id: string) => setListingId(id)

  const [listing, setListing] = useState<T.IListing | null>(null)
  const [photos, setPhotos] = useState<T.IPhoto[] | null>(null)

  useEffect(() => {
    if (!listingId) {
      setListing(null)
      setPhotos(null)
      return
    }

    const loadListingData = async () => {
      const [listingResponse, photosResponse] = await Promise.all([
        api.getPublicListing(listingId),
        api.getPublicListingPhotos(listingId),
      ])

      if (listingResponse.ok && photosResponse.ok) {
        if (listingResponse.data) setListing(listingResponse.data)

        if (photosResponse.data) setPhotos(photosResponse.data)
      }
    }

    loadListingData()
  }, [listingId])

  const [modalVisible, setModalVisible] = useState(false)
  const closeModal = () => setListingId('')

  useEffect(() => {
    setModalVisible(!!listingId)
  }, [listingId])

  return {
    listing,
    listingPhotos: photos,
    listingModalVisible: modalVisible,
    handleHighlightedListingChange,
    closeListingModal: closeModal,
  }
}

export default useSelectedListing
